import React from 'react';
import { CircularProgress } from '@mui/material';
import Redundancy from '../../../components/Administrations/Redundancy/Redundancy';
import TriSync from '../../../components/Administrations/Redundancy/TriSync/TriSync';
import ActivityLog from '../../../components/Administrations/Redundancy/ActivityLog/ActivityLog';
import { useGeoRedundancy } from './hooks';
import { useAuthForm } from '../../../components/Auth/hooks';

const GeoRedundancy = () => {

  const {data,isLoading,error} = useGeoRedundancy()
  const {statusData,statusError} = useAuthForm()

  const determineComponent = (haState: string | undefined) => {
  
    switch (haState) {
      case 'SA':
      case 'CONFIGURING':
        return <Redundancy />;
      case undefined:
        return <p className="text-foreground">No redundancy state available</p>;
      default:
        return <TriSync />;
    }
  };
  if (isLoading) {
    return <CircularProgress />;
  }

  if (statusError) {
    return <p className="text-destructive">Error loading redundancy status</p>;
  }

  return (
    <div className="flex flex-col gap-4 p-5">
      <div className="w-full">
        <div className="flex flex-col gap-4">
          <div className="w-full">
            {determineComponent(statusData?.ha_state)}
          </div>
        </div>
      </div>
      <ActivityLog/>
    </div>
  );
};

export default GeoRedundancy;
